/**
 * Le navigateur ne revérifie le service worker (sw.js) qu'à une navigation
 * complète. Kaiylo est une SPA : un onglet Safari laissé ouvert des jours ne
 * navigue jamais et reste sur l'ancienne version (21/10 : un coach sur
 * Safari 16.1 encore sur une release vieille de deux jours, après un
 * correctif). On demande donc une vérification toutes les heures, et quand
 * l'onglet redevient visible (au plus une fois toutes les 5 minutes, pour ne
 * pas en lancer une à chaque aller-retour entre deux apps).
 *
 * Si une nouvelle version est trouvée, registerSW (registerType 'autoUpdate')
 * recharge la page une fois qu'elle est active.
 */
const CHECK_EVERY_MS = 60 * 60 * 1000;
const MIN_GAP_ON_VISIBLE_MS = 5 * 60 * 1000;

export function watchServiceWorkerUpdates(registration, { win = window, doc = document, now = Date.now } = {}) {
  if (!registration) return () => {};

  // L'enregistrement vient de vérifier sw.js.
  let lastCheck = now();
  const check = (minGap) => {
    if (now() - lastCheck < minGap) return;
    if (registration.installing || win.navigator.onLine === false) return;
    lastCheck = now();
    // Hors ligne, Safari ancien… : un échec ne doit rien casser ni remonter
    // dans Sentry, la vérification suivante réessaiera.
    new Promise((resolve) => resolve(registration.update())).catch(() => {});
  };

  const timer = win.setInterval(() => check(0), CHECK_EVERY_MS);
  const onVisibilityChange = () => {
    if (doc.visibilityState === 'visible') check(MIN_GAP_ON_VISIBLE_MS);
  };
  doc.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    win.clearInterval(timer);
    doc.removeEventListener('visibilitychange', onVisibilityChange);
  };
}
